import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  buttonGroup: {
    border: "none !important"
  },
  InventoryListWrapper: {
    "& .menu": {
      "& .item": {
        justifyContent: "center",
        flex: 1,
        backgroundColor: "#CCDEEE !important",
        color: "#465869 !important",
        fontWeight: "bold !important",
        "&:first-child": {
          borderRadius: "4px 0px 0px 4px !important",
          borderBottomLeftRadius: "4px !important",
          borderRight: "none !important"
        },
        "&:nth-child(2)": {
          borderRadius: "0 !important"
        },
        "&:nth-child(3)": {
          borderRadius: "0 4px 4px 0 !important",
          borderLeft: "none !important"
        },
        "&.active": {
          backgroundColor: "#308CDB !important",
          color: "#fff !important"
        }
      }
    }
  },
  AddItemToListInventory: {
    background: "#465869",
    color: "#fff"
  },
  AddItemListInventory: {
    padding: 0,
    margin: 0,
    "&:hover": {
      background: "transparent",
      opacity: 0.8
    }
  },
  letter: {
    textDecoration: "underline"
  },
  letterActive: {
    textDecoration: "underline",
    color: "#308CDB"
  },
  ulListOfItems: {
    width: "100%",
    listStyle: "none",
    marginLeft: 0
  },
  textItem: {
    color: "#465869",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    cursor: "pointer",
    "&:hover": {
      background: "transparent",
      opacity: 0.8
    }
  },
  containerListContent: {
    paddingTop: "10px"
  },
  containerButtonItemsPanel: {
    display: "flex",
    justifyContent: "center"
  },
  button: {
    width: "50%"
  },
  item: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px"
  },
  mb2: {
    marginBottom: 12
  }
}));

export default styles;
